<div class="status" *ngIf="value" [class]="colorToSet">{{value}}</div>
